import type { HTMLProps, LegacyRef } from 'react';
import { forwardRef } from 'react';
import { DateRangePicker, type DateRangePickerProps } from 'rsuite';
import type { DateRange } from 'rsuite/esm/DateRangePicker';
import {
  addDays,
  endOfWeek,
  startOfWeek,
} from 'rsuite/esm/internals/utils/date';

// type Error = 
export type ErrorStatus =
  | { tag: "Submited", errors: string[] }
  | { tag: "Not submitted" }

/**
 * Conigure ranges.
 */
const predefinedRanges: DateRangePickerProps['ranges'] = [
  { label: "Aujourd'hui", value: [new Date(), new Date()] },
  { label: 'Hier', value: [addDays(new Date(), -1), addDays(new Date(), -1)] },
  {
    label: 'Cette semaine',
    value: [startOfWeek(new Date()), endOfWeek(new Date())],
  },
];

/**
 * Component props.
 */
export interface PeriodPickerProps extends HTMLProps<HTMLInputElement> {
  defaultValues?: [string, string];
  label?: string;
  required?: boolean;
  handleDateUpdate: (interval: DateRange) => void;
  handleOnClean: () => void | undefined;
  className?: string;
  errors: ErrorStatus;
}

function PeriodPickerComponent(
  { className, defaultValues, label, handleDateUpdate, handleOnClean, required, errors }: PeriodPickerProps,
  ref: LegacyRef<HTMLDivElement> | undefined
) {

  const isSubmited = errors.tag === "Submited";
  const errorList = isSubmited ? errors.errors : [];

  className =
    isSubmited && errorList.length > 0 ? "form-danger" :
      isSubmited ? "form-success" :
        "";

  // DatePicker id.
  const id = `property-1-datetime-range`;

  const startDate = defaultValues ? new Date(`${defaultValues[0]}Z`) : null;
  const endDate = defaultValues ? new Date(`${defaultValues[1]}Z`) : null;

  return (
    <div ref={ref} className={`input-box ${className || ''} uk-margin`}>
      <label className="uk-form-label" htmlFor={id} >
        {label} {required && <span style={{ color: 'red' }}>*</span>}
      </label>
      <DateRangePicker
        id={id}
        className={className}
        block
        ranges={predefinedRanges}
        weekStart={1}
        character=" - "
        placement="autoVertical"
        defaultValue={startDate && endDate
          ? [new Date(startDate), new Date(endDate)]
          : undefined}
        onChange={(value) => {
          value && handleDateUpdate(value);
        }}
        onClean={() => handleOnClean()}
        placeholder="Choisir une période"
        format="dd/MM/yyyy HH:mm"
      />
      {isSubmited && errorList.length > 0 &&
        (<div style={{ fontSize: "13px" }}>
          {errorList.map(err =>
            <p style={{ color: 'red', margin: '0', marginTop: '5px' }} className="form-danger warning">
              <span uk-icon="icon: warning; ratio: 0.8"></span> {err}
            </p>

          )}
        </div>)}
    </div>
  );
}

export default forwardRef(PeriodPickerComponent);
